(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loverse-cart-savings"] && !Shopify.designMode) return;
  try {
    /*
   * Confetti over the savings ladder when the cart reaches a higher tier than before in
   * this tab (2 → 3 portraits: yes; reload or removal: no). The cart re-renders the
   * ladder on every change, so the last tier seen is kept in sessionStorage.
   */
  if (!customElements.get('lve-savings-fx')) {
    customElements.define(
      'lve-savings-fx',
      class extends HTMLElement {
        static observedAttributes = ['percent'];
        static KEY = 'lve-savings-tier';
        static COLORS = ['#a8394f', '#e0a82e', '#3f6b4f', '#f2c4ce', '#6b2737'];

        connectedCallback() {
          this.check();
        }

        attributeChangedCallback() {
          if (this.isConnected) this.check();
        }

        check() {
          const percent = Number(this.getAttribute('percent')) || 0;
          let last = null;
          try {
            last = sessionStorage.getItem(this.constructor.KEY);
            sessionStorage.setItem(this.constructor.KEY, String(percent));
          } catch {
            return;
          }
          if (last === null || percent <= Number(last)) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.burst();
        }

        burst() {
          this.replaceChildren();
          const colors = this.constructor.COLORS;
          for (let n = 0; n < 14; n++) {
            const piece = document.createElement('i');
            piece.style.left = `${4 + ((n * 7) % 92)}%`;
            piece.style.background = colors[n % colors.length];
            piece.style.animationDelay = `${(n % 5) * 40}ms`;
            piece.style.setProperty('--x', `${((n % 3) - 1) * 18}px`);
            piece.style.setProperty('--r', `${n % 2 ? 220 : -200}deg`);
            this.append(piece);
          }
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.replaceChildren(), 1200);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loverse-header-styles"] && !Shopify.designMode) return;
  try {
    /* search_used: once per page, when the shopper types in the search
     modal (or submits a search form), pushed to the dataLayer like the home events. */
  (() => {
    let sent = false;
    const push = (source) => {
      if (sent) return;
      sent = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'search_used', source });
      } catch (error) {
        /* analytics must never break search */
      }
    };
    document.addEventListener('input', (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.name === 'q' && input.value.trim().length > 1) push('typed');
    });
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.querySelector('input[name="q"]')) push('submitted');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
